export const detectBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('chrome') > -1 || !!(window as unknown as { chrome: boolean }).chrome)
        return 'Chrome';
    if (userAgent.indexOf('safari') > -1) return 'Safari';
    if (userAgent.indexOf('firefox') > -1) return 'Firefox';
    if (userAgent.indexOf('edge') > -1) return 'Edge';
    return '';
};
